var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{attrs:{"src":_vm.src,"width":_vm.width,"height":_vm.height,"frameborder":_vm.frameBorder,"scrolling":_vm.scrolling}})}
var staticRenderFns = []

export { render, staticRenderFns }